import {observer} from "mobx-react";
import {BUTTON_VARIANTS} from "../../../../components/inputs/button-variants";
import {Button} from "../../../../components/inputs/button/button";

interface IOnBoardingButton {
    onClick: () => void,
    buttonText?: string,
    isLoading?: boolean,
    paddingTop?: number,
    paddingBottom?: number
}

const OnBoardingButton: React.FC<IOnBoardingButton> = observer((
    {
        onClick,
        buttonText,
        isLoading,
        paddingTop,
        paddingBottom
    }
) => {
    return <div className="onboarding-button" style={{paddingTop: paddingTop, paddingBottom: paddingBottom}}>
        <Button
            variant={BUTTON_VARIANTS.PrimaryAccent}
            text={buttonText}
            onClick={onClick}
            hasLoader={true}
            isLoading={isLoading}
        />
    </div>
})

export default OnBoardingButton;
